import localStorage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import services from './services';
import reducers from './reducers';
import { FLUSH } from 'redux-persist';
import {
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE
} from 'redux-persist/es/constants';

const persistConfig = {
  key: 'root',
  storage: localStorage,
  whitelist: [
    // 'userData',
    'selectedDomain',
    'recentVisit',
    'helpersShow',
    'notifShow',
    'joyTourShow'
  ]
};

const reducer = combineReducers({
  ...Object.fromEntries(reducers.map(slice => [slice.name, slice.reducer])),
  ...Object.fromEntries(services.map(api => [api.reducerPath, api.reducer]))
});
const rootReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }),
    ...services.map(service => service.middleware)
  ],
});
export const persistor = persistStore(store);
